import React, { Component } from "react";
import { Button, Form, Select } from "semantic-ui-react";
import LineCharts from "components/charts/lineCharts";
import { HomepageContext } from "context/homepageProvider";
import "scss/screens/homepage/serviceSummary.scss";
import SemanticDatepicker from "react-semantic-ui-datepickers";

export default class ServiceSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkDate: null,
      pic: "",
      modal: "",
    };
  }

  createDevicesStatus = () => {
    return (
      <>
        <div className="status">
          <div className="status-blue">
            <div className="status-blue-title">
              คำขอที่แจ้งเข้ามาทั้งหมด
              </div>
            <div className="status-blue-amount">
              {this.context.serviceSummaryList?.maintenances?.total}
            </div>
          </div>

          <div className="status-green">
            <div className="status-green-title">
              คำขอที่แก้ไขแล้วทั้งหมด
              </div>
            <div className="status-green-amount">
              {this.context.serviceSummaryList?.maintenances?.complete}
            </div>
          </div>

          <div className="status-orange">
            <div className="status-orange-title">
              คำขอที่อยู่ในระหว่างการแก้ไข
              </div>
            <div className="status-orange-amount">
              {this.context.serviceSummaryList?.maintenances?.in_process}
            </div>
          </div>

          <div className="status-red">
            <div className="status-red-title">
              คำขอที่เกินกำหนดการแก้ไข
              </div>
            <div className="status-red-amount">
              {this.context.serviceSummaryList?.maintenances?.overdue}
            </div>
          </div>
        </div>
      </>
    );
  };

  createSearchService = () => {
    const devicesOptions = [
      { key: "all", text: "ทั้งหมด", value: "" },
      { key: "colper-5000k", text: "COLPER-5000K", value: "colper-5000k" },
      { key: "acr-100plus", text: "ACR-100PLUS", value: "acr-100plus" },
    ];
    const responsibleOptions = [
      // { key: "บิ๊ก", text: "บิ๊ก", value: "บิ๊ก" },
       {key: "", text: "", value: ""},
    ];
    const { model, pic, checkDate } = this.state;
    return (
      <>
        <div className="search">
          <Form>
            <Form.Group inline>
              <Form.Field
                control={Select}
                options={devicesOptions}
                placeholder="ทั้งหมด"
                search
                value={model}
                onChange={(e, { value }) => this.setState({ model: value })}
              />
              <Form.Field
                control={Select}
                options={responsibleOptions}
                placeholder="ชื่อผู้รับผิดชอบ"
                search
                value={pic}
                onChange={(e, { value }) => this.setState({ pic: value })}
              />
              <SemanticDatepicker
                onChange={(e, { value }) =>
                  this.setState({
                    checkDate: value,
                  })
                }
                placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                type="range"
              />
              <Button color="blue" onClick={() => this.setDataForSearch()}>
                ค้นหา
              </Button>
            </Form.Group>
          </Form>
        </div>
      </>
    );
  };

  setDataForSearch = () => {
    const { checkDate, pic, model } = this.state;
    if (checkDate != null && checkDate.length > 1) {
      const data = {
        pic: pic,
        model: model,
        min_date: checkDate[0].toLocaleString().substring(0, 8),
        max_date: checkDate[1].toLocaleString().substring(0, 8),
      };
      this.context.getServiceSummary(data);
    } else if (checkDate == null) {
      const data = {
        pic: pic,
        model: model,
        min_date: checkDate,
        max_date: checkDate,
      };
      this.context.getServiceSummary(data);
    }
  };

  render() {
    return (
      <div className="serviceSummary">
        {this.createDevicesStatus()}

        {this.createSearchService()}

        <LineCharts />
      </div>
    );
  }
}

ServiceSummary.contextType = HomepageContext;
